import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';

import { Field, reduxForm } from 'redux-form';

import TextField from 'components/fields/TextField';
import RadioButtonField from 'components/fields/RadioButtonField';
import RadioGroupField from 'components/fields/RadioGroupField';
import AutosuggestField from 'components/fields/AutosuggestField';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import { requestSearchUsers } from 'redux/modules/users';
import { accountLoginFail } from 'redux/modules/account';

const styles = theme => ({
  gridItemSecondary: {
    maxWidth: '16%',
    flexBasis: '16%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '50%',
      flexBasis: '50%',
    },
  },
  gridItemPrimary: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  gridItemTertiary: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '50%',
      flexBasis: '50%',
    },
  },
  paperRadiogroup: {
    display: 'inline-flex',
  },
  gridContainer: {
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
});

function onChange(values, dispatch, props) {
  if (values['Watcher ID']
    && values['Selected User Name']
    && values['Selected User Name'] !== values['User Name']) {
    dispatch(props.change('Watcher ID', ''));
  }
}

const PatientsFilterForm = ({
  handleSubmit, change, actions, classes, className,
}) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Grid
      className={classes.gridContainer}
      container
      justify="flex-start"
      alignItems="center"
      spacing={24}
    >
      <Grid
        item
        xs={3}
        className={classes.gridItemPrimary}
      >
        <Paper className={classes.root}>
          <Field
            id="Name or PRN"
            name="Name or PRN"
            component={TextField}
            type="text"
            placeholder="Search by Patient Name or PRN"
            fullWidth
            endAdornmentClearButton
          />
        </Paper>
      </Grid>
      <Grid
        item
        className={classes.gridItemSecondary}
      >
        <Paper>
          <Field
            id="Date of Birth"
            name="Date of Birth"
            component={TextField}
            type="text"
            placeholder="DOB"
            fullWidth
            validate={[validate.date]}
            normalize={normalize.date}
            errorPlacement="bottom"
            endAdornmentClearButton
          />
        </Paper>
      </Grid>
      <Grid
        item
        className={classes.gridItemSecondary}
      >
        <Paper>
          <Field
            id="Insurance Code"
            name="Insurance Code"
            component={TextField}
            type="text"
            placeholder="Insurance ID"
            fullWidth
            errorPlacement="bottom"
            endAdornmentClearButton
          />
        </Paper>
      </Grid>
      <Grid
        item
        className={classes.gridItemSecondary}
      >
        <Paper>
          <Field
            id="User Name"
            name="User Name"
            placeholder="Watched By"
            component={AutosuggestField}
            fullWidth
            renderSuggestionContent={suggestion =>
              `${suggestion['First Name']} ${suggestion['Last Name']}`}
            renderInputContent={suggestion => `${suggestion['First Name']} ${suggestion['Last Name']}`}
            onSuggestionSelected={(suggestion) => {
              change('Watcher ID', suggestion.ID);
              change('Selected User Name', `${suggestion['First Name']} ${suggestion['Last Name']}`);
              return `${suggestion['First Name']} ${suggestion['Last Name']}`;
            }}
            fetchSuggestions={({ value, limit, offset }) => (
              value.length > 0
                ? requestSearchUsers({
                  filters: [
                    {
                      name: 'Role',
                      operation: 'nin',
                      val: ['System'],
                    },
                    {
                      name: 'Full Name',
                      operation: 'startswith',
                      val: value,
                      case_sensitivity: false,
                    },
                  ],
                  limit,
                  offset,
                }).then(res => res.data,
                  (err) => {
                    if (err.data.error === 'Need authorisation') {
                      actions.accountLoginFail();
                    }
                    return err;
                  })
                : requestSearchUsers({
                  filters: [
                    {
                      name: 'Role',
                      operation: 'nin',
                      val: ['System'],
                    },
                  ],
                  limit,
                  offset,
                }).then(res => res.data,
                  (err) => {
                    if (err.data.error === 'Need authorisation') {
                      actions.accountLoginFail();
                    }
                    return err;
                  })
            )}
            listWidth="auto"
            onlyConfirmedSelection
            clearSearchValueAfterSelection
            keepOpenAfterSelection
          />
        </Paper>
      </Grid>
      <Grid item className={classes.gridItemTertiary}>
        <Paper className={classes.paperRadiogroup}>
          <FormControl role="group">
            <Field
              name="Patient Status"
              component={RadioGroupField}
            >
              {['All', 'Active', 'Inactive'].map(item => (
                <RadioButtonField
                  key={item}
                  value={item}
                  label={item}
                  color="primary"
                />
              ))}
            </Field>
          </FormControl>
        </Paper>
      </Grid>
    </Grid>
  </form>
);

PatientsFilterForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    gridItemSecondary: PropTypes.string.isRequired,
  }).isRequired,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(reduxForm({
  onSubmit: () => {},
  onChange,
  destroyOnUnmount: false,
  initialValues: {
    'Patient Status': 'All',
  },
})(withStyles(styles)(PatientsFilterForm)));



// WEBPACK FOOTER //
// ./src/components/patient/PatientsFilter/PatientsFilterForm.js